<div class="logout-container">
  <h1>You've been logged out.</h1>
  <a mat-raised-button color="primary" [routerLink]="['/login']">Login</a>
</div>
